export default "__VITE_ASSET__90194f24__"